
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMeberStatusDialog extends Serenity.EntityDialog<PsMeberStatusRow, any> {
        protected getFormKey() { return PsMeberStatusForm.formKey; }
        protected getIdProperty() { return PsMeberStatusRow.idProperty; }
        protected getLocalTextPrefix() { return PsMeberStatusRow.localTextPrefix; }
        protected getNameProperty() { return PsMeberStatusRow.nameProperty; }
        protected getService() { return PsMeberStatusService.baseUrl; }
        protected getDeletePermission() { return PsMeberStatusRow.deletePermission; }
        protected getInsertPermission() { return PsMeberStatusRow.insertPermission; }
        protected getUpdatePermission() { return PsMeberStatusRow.updatePermission; }

        protected form = new PsMeberStatusForm(this.idPrefix);

    }
}